import { __extends } from "tslib";
import { ImageTextureCube } from './ImageTextureCube';
var DepthTextureCube = /** @class */ (function (_super) {
    __extends(DepthTextureCube, _super);
    function DepthTextureCube(image) {
        if (image === void 0) { image = null; }
        return _super.call(this, image) || this;
    }
    Object.defineProperty(DepthTextureCube.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return DepthTextureCube.assetType;
        },
        enumerable: true,
        configurable: true
    });
    DepthTextureCube.assetType = '[texture DepthTextureCube]';
    return DepthTextureCube;
}(ImageTextureCube));
export { DepthTextureCube };
import { ShaderBase } from '@awayjs/renderer';
import { _Shader_ImageTexture } from './ImageTextureCube';
/**
 *
 * @class away.pool._Shader_ImageTexture2D
 */
var _Shader_DepthTexture = /** @class */ (function (_super) {
    __extends(_Shader_DepthTexture, _super);
    function _Shader_DepthTexture() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _Shader_DepthTexture.prototype._initVO = function (chunkVO) {
        this._decodeReg = null;
        this._decodeIndex = -1;
    };
    /**
     *
     *
     * @internal
     */
    _Shader_DepthTexture.prototype._initConstants = function () {
        var fragmentData = this._shader.fragmentConstantData;
        var index = this._decodeIndex;
        fragmentData[index] = 1.0;
        fragmentData[index + 1] = 1 / 255.0;
        fragmentData[index + 2] = 1 / 65025.0;
        fragmentData[index + 3] = 1 / 16581375.0;
    };
    /**
     * @inheritDoc
     */
    _Shader_DepthTexture.prototype._getFragmentCode = function (targetReg, regCache, sharedReg, inputReg) {
        if (this._decodeIndex == -1)
            this._decodeIndex = (this._decodeReg = regCache.getFreeFragmentConstant()).index * 4;
        var temp = regCache.getFreeFragmentVectorTemp();
        return _super.prototype._getFragmentCode.call(this, temp, regCache, sharedReg, inputReg) +
            'dp4 ' + targetReg + '.w, ' + temp + ', ' + this._decodeReg + '\n';
    };
    return _Shader_DepthTexture;
}(_Shader_ImageTexture));
export { _Shader_DepthTexture };
ShaderBase.registerAbstraction(_Shader_DepthTexture, DepthTextureCube);
